<div
	class="rx-card"
	[class.read-only]="isReadOnly$ | async"
    *ngIf="formState$ | async as formState"
>
	<div class="rx-card-title">
		<div
			class="rx-title-row rx-app-flex-container-row rx-app-flex-container-row--align-center"
		>
			<div class="rx-card-title-text">{{ 'OrderSection.Order' | translate }}:</div>
		</div>
	</div>
	<form
		class="rx-card-body rx-app-flex-container-row rx-app-flex-container-row--justify-space-between"
		[formGroup]="orderForm"
	>
		<div class="rx-app-flex-container-column rx-app-flex--half">
			<rx-case-type-selector
				[isRequired]="(isReadOnly$ | async) === false && (isReturned$ | async) === false"
				[formControl]="caseTypeControl"
				[options]="caseTypes$ | async"
				name="caseTypeControl"
				ngDefaultControl
                [class.read-only]="(isCaseTypeReadOnly$ | async) || (isReturned$ | async)"
			></rx-case-type-selector>

			<rx-simple-form-field *ngIf="formState?.multiBite?.isVisible">
                <tlk-slide-toggle
                [formControl]="isMultiBiteSelectedControl"
                name="isMultiBiteSelected"
				ngDefaultControl
            >
                {{ "OrderSection.MultiBite" | translate }}
            </tlk-slide-toggle>
            </rx-simple-form-field>
			<rx-due-date-picker
				*ngIf="formState?.dueDate?.isVisible"
				[formControl]="dueDateControl"
                [isRequired]="formState?.dueDate?.isRequired"
                [isReadOnly]="isReadOnly$ | async"
				[minimalAvailableDueDate]="minimalAvailableDueDate$ | async"
				[maxDueDate]="maxDueDate$ | async"
				name="dueDateControl"
				ngDefaultControl
			></rx-due-date-picker>
		</div>

		<div class="rx-app-flex-container-column rx-app-flex--half">
			<rx-select
			*ngIf="formState?.sendTo?.isVisible"
			gdArea="sendToLab"
			[id]="'send-to-lab'"
			[label]="'OrderSection.SendTo' | translate"
			[class.send-to-selector-read-only]="isReadOnly$ | async"
			labelSeparator=":"
			[isReadOnly]="isReadOnly$ | async"
			[formControl]="sendToControl"
            [isRequired]="formState?.sendTo.isRequired"
			[isCancellable]="(isReadOnly$ | async) === false"
            (cancelSelection)="handleCancelSendToLabSelection()"
			[options]="availableLabs$ | async"
			name="sendToControl"
			ngDefaultControl
			></rx-select>

			<rx-select
			*ngIf="formState?.treatmentStage?.isVisible"
			gdArea="treatmentStage"
			[id]="'treatment-stage'"
			[label]="'OrderSection.TreatmentStage' | translate"
			labelSeparator=":"
			[isReadOnly]="(isReadOnly$ | async) || (isReturned$ | async)"
			[formControl]="treatmentStageControl"
			[isCancellable]="(isViveraCasetypeSelected$ | async) === false && (isReadOnly$ | async) === false && (isReturned$ | async) === false"
			[options]="treatmentStages$ | async"
			name="treatmentStageControl"
			ngDefaultControl
			></rx-select>

			<rx-current-aligner-input
				*ngIf="formState?.currentAlignerId?.isVisible"
				[formControl]="currentAlignerIdControl"
				[isReadOnly]="(isReadOnly$ | async) || (isReturned$ | async)"
				name="currentAlignerIdControl"
				ngDefaultControl
			></rx-current-aligner-input>
		</div>
	</form>
</div>